<div class="section-header d-flex align-items-center justify-content-between">
  <span class="text-muted" i18n="UserMenu@@userMenuWelcomeTitle">Welcome</span>
  <atx-switch
    inputId="user-availability"
    [formControl]="availability"
    data-e2e="user-availability-status"
  >
    <span i18n="UserMenu@@userMenuAvailabilitySwitch">
      I'm available
    </span>
  </atx-switch>
</div>
